<template>
  <Accordion
    :error="transport.error"
    id="info-transport"
    title="TRANSPORTADOR / VOLUMES"
  >
    <b-row class="row-padding">
      <b-col sm="6" md="4">
        <SelectWithSearch
          label="Razão Social"
          placeholder="Pesquise uma transportadora"
          ref="searchShippingCompany"
          v-model="transport.shippingCompany"
          :options="shippingCompanyCollection"
          :change="changeShippingCompanySelected"
          :search="searchShippingCompany"
        >
          <template slot="options" slot-scope="props">
            <div class="selected" style="text-transform: uppercase">
              {{ props.data.name }}
              <br />
              CPF/CNPJ {{ props.data.identificationFormatted }}
            </div>
          </template>
          <template slot="no-options">
            Nenhuma transportadora encontrada
          </template>
          <template slot="selected" slot-scope="props">
            <div class="selected" style="text-transform: uppercase">
              {{ props.data.name }}
            </div>
          </template>
        </SelectWithSearch>
      </b-col>
      <b-col sm="6" md="3">
        <Label>CPF/CNPJ:</Label>
        <b-form-input
          :value="transport.shippingCompany.identificationFormatted"
          disabled
        >
        </b-form-input>
      </b-col>
      <b-col sm="6" md="2">
        <SelectWithSearch
          label="Frete"
          labelBusca="name"
          placeholder="Pesquise o frete"
          ref="searchFreightCollection"
          v-model="transport.freight"
          :clearable="false"
          :disabled="!transport.shippingCompany.name"
          :options="freightCollection"
          :change="changeFreightSelected"
          :search="searchFreight"
        >
          <template slot="options" slot-scope="props">
            <div class="selected" style="text-transform: uppercase">
              {{ props.data.id }} - {{ props.data.name }}
            </div>
          </template>
          <template slot="no-options"> Selecione um tipo de frete </template>
          <template slot="selected" slot-scope="props">
            <div class="selected" style="text-transform: uppercase">
              {{ props.data.id }}
            </div>
          </template>
        </SelectWithSearch>
      </b-col>
      <b-col sm="6" md="3">
        <SelectWithSearch
          label="Veículo"
          labelBusca="placa"
          placeholder="Pesquise o veículo"
          v-model="transport.vehicle"
          :disabled="!transport.shippingCompany.name"
          :options="vehicleCollection"
          :change="changeVehicle"
          :clearable="false"
        >
          <template slot="options" slot-scope="props">
            <div class="selected" style="text-transform: uppercase">
              {{ props.data.placa }}
            </div>
          </template>
          <template slot="no-options"> Nenhum veículo encontrado</template>
          <template slot="selected" slot-scope="props">
            <div class="selected" style="text-transform: uppercase">
              {{ props.data.placa }}
            </div>
          </template>
        </SelectWithSearch>
      </b-col>
    </b-row>
    <b-row class="row-padding">
      <b-col md="12">
        <SelectWithSearch
          label="Endereço"
          labelBusca="street"
          placeholder="Pesquise o endereço"
          v-model="transport.address"
          :disabled="!transport.shippingCompany.name"
          :options="addressCollection"
          :change="changeAddress"
          :clearable="false"
        >
          <template slot="options" slot-scope="props">
            <div class="selected" style="text-transform: uppercase">
              {{ props.data.street }}, {{ props.data.number }},
              {{ props.data.neighbourhood }}
            </div>
          </template>
          <template slot="no-options"> Nenhum endereço encontrado </template>
          <template slot="selected" slot-scope="props">
            <div
              v-if="props.data.street"
              class="selected"
              style="text-transform: uppercase"
            >
              {{ props.data.street }}, {{ props.data.number }},
              {{ props.data.neighbourhood }}
            </div>
            <div v-else class="selected" style="text-transform: uppercase">
              {{ props.data.street }} {{ props.data.number }}
              {{ props.data.neighbourhood }}
            </div>
          </template>
        </SelectWithSearch>
      </b-col>
    </b-row>
    <div class="divider"></div>
    <b-row class="row-padding align-items-end">
      <b-col sm="6" md="2">
        <InputQuantity
          ref="amountVolume"
          :precision="0"
          :max="19"
          id="amountVolume"
          label="Quantidade"
          inputClass="form-control input"
          labelBold
          v-model="transport.volume.amountVolume"
        />
      </b-col>
      <b-col sm="6" md="2">
        <Input
          ref="species"
          id="species"
          label="Espécie"
          inputClass="form-control input"
          labelBold
          v-model="transport.volume.species"
        />
      </b-col>
      <b-col sm="6" md="2">
        <Input
          ref="brand"
          id="brand"
          label="Marca"
          inputClass="form-control input"
          labelBold
          v-model="transport.volume.brand"
        />
      </b-col>
      <b-col sm="6" md="2">
        <InputQuantity
          ref="grossWeight"
          :precision="3"
          id="grossWeight"
          label="Peso Bruto"
          inputClass="form-control input"
          labelBold
          v-model="transport.volume.grossWeight"
        />
      </b-col>
      <b-col sm="6" md="2">
        <InputQuantity
          ref="netWeight"
          :precision="3"
          id="netWeight"
          label="Peso Líquido"
          inputClass="form-control input"
          labelBold
          v-model="transport.volume.netWeight"
        />
      </b-col>
      <b-col sm="6" md="2">
        <Input
          ref="numeration"
          id="numeration"
          label="Numeração"
          inputClass="form-control input"
          labelBold
          v-model="transport.volume.numeration"
        />
      </b-col>
    </b-row>
  </Accordion>
</template>

<script>
import { Accordion } from '@/components';
import { mapState, mapActions } from 'vuex';
import {
  SelectWithSearch,
  Label,
  InputQuantity,
  Input,
} from '@/components/Form';
import FormatMixin from '../../../../../Application/mixins/FormatMixin';
import { NO_FREIGHT } from '../../../../../Fiscal/modules/Freight/enums/freightEnum';
import { MAIN } from '../../../../../Application/enums/AddressType';

export default {
  name: 'transport',
  mixins: [FormatMixin],
  components: {
    Accordion,
    SelectWithSearch,
    Label,
    InputQuantity,
    Input,
  },
  async mounted() {
    await Promise.all([
      this.setShippingCompanyCollection(),
      this.setFreightCollection(),
    ]);
    if (this.transport?.id) {
      await this.setPropsOnEdit();
      return;
    }
    this.setDefaultFreight();
  },
  computed: {
    ...mapState('purchase', ['transport']),
    ...mapState('person', [
      'shippingCompanyCollection',
      'vehicleCollection',
      'addressCollection',
    ]),
    ...mapState('freight', ['freightCollection']),
  },
  methods: {
    ...mapActions('person', [
      'setVehicleCollection',
      'setShippingCompanyCollection',
      'setAddressCollection',
    ]),
    ...mapActions('purchase', ['setShippingCompanyById']),
    ...mapActions('freight', ['setFreightCollection']),
    async setPropsOnEdit() {
      await this.setShippingCompanyById(this.transport);
      const { shippingCompany } = this.transport;
      await this.setAddressCollection(shippingCompany);
      await this.setVehicleCollection(shippingCompany);
      this.setFreight();
      this.setVehicle();
    },
    setFreight() {
      if (this.transport.id && this.transport?.freight) {
        this.transport.freight = this.freightCollection.find(
          (e) => this.transport.freight.id === e.id,
        );
      }
    },
    setVehicle() {
      if (this.transport.id && this.transport?.vehicle) {
        this.transport.vehicle = this.vehicleCollection.find(
          (e) => this.transport.vehicle.identification === e.description,
        );
      }
    },
    async searchShippingCompany(search = null) {
      if (search) {
        await this.setShippingCompanyCollection(search);
      }
    },
    changeShippingCompanySelected(selected) {
      if (selected) {
        this.setAddressCollection(selected);
        this.setVehicleCollection(selected);
        this.transport.shippingCompany = selected;
        this.transport.vehicle = {};
        this.transport.address = {};

        if (this.vehicleCollection) {
          const [firstVehicle] = this.vehicleCollection;
          this.transport.vehicle = firstVehicle;
        }

        if (this.addressCollection?.length) {
          const mainAddress = this.addressCollection.find(
            (e) => e.type === MAIN,
          );
          this.transport.address = mainAddress;
        }

        return;
      }

      this.transport.shippingCompany = [];
      this.transport.vehicle = [];
      this.transport.address = [];
    },
    setDefaultFreight() {
      this.transport.freight = this.freightCollection.find(
        (e) => e.id === NO_FREIGHT,
      );
    },
    async searchFreight(search = null) {
      if (search) {
        await this.setFreightCollection(search);
      }
    },
    changeAddress(selected) {
      if (selected) {
        this.transport.address = selected;
      }
    },
    changeVehicle(selected) {
      if (selected) {
        this.transport.vehicle = selected;
      }
    },

    changeFreightSelected(selected) {
      if (selected) {
        this.transport.freight = selected;
      }
    },
  },
};
</script>
